module.exports = __webpack_public_path__ + "static/img/icons_contracts_blue.5be5bba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu-icons/icons_contracts_blue.svg
// module id = SpCy
// module chunks = 1